export const DashboardDeviceColumn = {
    Name: 'name',
    Nickname: 'nickname',
    LicensePlate: 'licensePlate',
    Group: 'groupName',
    Identifier: 'uniqueId',

    get(value) {
        return this.all().find(x => x.value === value);
    },
    all() {
        return [
            {
                value: DashboardDeviceColumn.Name,
                translationKey: 'dashboard.devices.table.name'
            },
            {
                value: DashboardDeviceColumn.Nickname,
                translationKey: 'settings.car-fleet.form.vehicle-nickname',
                callback: (device, _, vehicles) => {
                    const vehicle = vehicles?.filter(item => item?.deviceId === device.id)[0] || null;
                    return vehicle?.nickname ?? '';
                }
            },
            {
                value: DashboardDeviceColumn.LicensePlate,
                translationKey: 'settings.on-board.devices.form.license-plate',
                callback: (device, _, vehicles) => {
                    const vehicle = vehicles?.filter(item => item?.deviceId === device.id)[0] || null;
                    return vehicle?.licensePlate ?? '';
                }
            },
            {
                value: DashboardDeviceColumn.Group,
                translationKey: 'generic.group',
                callback: (device, groups) => {
                    const group = groups?.filter(item => item?.id === device.groupId)[0] || null;
                    return group?.name ?? '';
                }
            },
            {
                value: DashboardDeviceColumn.Identifier,
                translationKey: 'dashboard.devices.table.uid'
            },
        ]
    }
}